/* assets/littleg-upload-reminders.js — FAMILY-DEADLINE-REMINDER-04
 * Owner: explicit guardian-triggered calendar reminder export and confirm-payload snapshot.
 * Deadline values are read only through window.LittleGNoticeDeadlines.
 * Confirm transport is augmented only through LittleGUploadTransport.registerConfirmContributor().
 * Locale copy is consumed from the existing LittleGUploadI18n owner.
 * Boundary: no notification permission, in-session timer, background scheduling claim or direct storage key.
 */
(function littleGDeadlineReminders(window, document) {
  'use strict';

  var VERSION = '2026-08-08-deadline-reminder-04';
  var HOST_SELECTOR = '[data-upload-reminder-contract]';
  var ROOT_SELECTOR = '[data-littleg-upload-workspace]';

  function clean(value) { return String(value == null ? '' : value).trim(); }
  function familyData() { return window.LittleGFamilyData || null; }
  function deadlineOwner() { return window.LittleGNoticeDeadlines || null; }
  function i18n(key, fallback, variables) {
    var owner = window.LittleGUploadI18n;
    return owner && typeof owner.t === 'function' ? owner.t(key, variables) : fallback;
  }
  function deadlineInput(kind) {
    var owner = deadlineOwner();
    return owner && typeof owner.getInput === 'function' ? owner.getInput(kind) : null;
  }
  function validDeadline(kind) {
    var owner = deadlineOwner();
    var deadline = owner && typeof owner.get === 'function' ? owner.get(kind) : null;
    var value = clean(deadline && deadline.due_at);
    return value && !Number.isNaN(new Date(value).getTime()) ? value : '';
  }
  function availableKinds() {
    return ['reply', 'payment'].filter(function (kind) { return validDeadline(kind); });
  }
  function selectedDeadline(host) {
    var select = host.querySelector('[data-reminder-kind]');
    var kind = clean(select && select.value) || 'reply';
    return { kind: kind, due_at: validDeadline(kind) };
  }
  function leadMinutes(host) {
    var node = host.querySelector('[data-reminder-lead]');
    var value = Number(node && node.value);
    return Number.isFinite(value) && value > 0 ? value : 1440;
  }
  function status(host, message, state) {
    var node = host.querySelector('[data-reminder-status]');
    if (node) node.textContent = message;
    host.setAttribute('data-reminder-state', state || 'idle');
  }
  function saveReminder(reminder) {
    var owner = familyData();
    if (!owner || typeof owner.getNoticeDraft !== 'function' || typeof owner.saveNoticeDraft !== 'function') return;
    var draft = owner.getNoticeDraft() || {};
    owner.saveNoticeDraft(Object.assign({}, draft, { reminder: reminder }));
  }
  function readReminder() {
    var owner = familyData();
    var draft = owner && typeof owner.getNoticeDraft === 'function' ? owner.getNoticeDraft() : null;
    return draft && draft.reminder || null;
  }
  function reminderSnapshot() {
    return readReminder() || { enabled: false };
  }
  function syncAvailability(host) {
    var kinds = availableKinds();
    host.hidden = kinds.length === 0;
    if (!kinds.length) return;
    var select = host.querySelector('[data-reminder-kind]');
    if (select) {
      Array.prototype.forEach.call(select.options, function (option) {
        option.hidden = kinds.indexOf(option.value) === -1;
        option.disabled = kinds.indexOf(option.value) === -1;
      });
      if (kinds.indexOf(select.value) === -1) select.value = kinds[0];
    }
  }
  function icsDate(value) {
    return new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }
  function downloadCalendar(host) {
    var deadline = selectedDeadline(host);
    if (!deadline.due_at) {
      status(host, i18n('reminderMissing', '請先填寫相應期限。'), 'missing_deadline');
      var input = deadlineInput(deadline.kind);
      if (input) input.focus();
      return;
    }
    var lead = leadMinutes(host);
    var label = 'LittleG｜' + i18n(
      deadline.kind === 'payment' ? 'paymentDeadline' : 'replyDeadline',
      deadline.kind === 'payment' ? '付款期限' : '回條／回覆期限'
    );
    var description = i18n('calendarStatus', '由裝置日曆在指定時間提醒。');
    var due = new Date(deadline.due_at);
    var start = icsDate(due);
    var end = icsDate(new Date(due.getTime() + 30 * 60000));
    var ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//LittleG//Family Notice//EN',
      'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      'UID:littleg-' + deadline.kind + '-' + due.getTime() + '@glhksolution.com',
      'DTSTAMP:' + icsDate(new Date()),
      'DTSTART:' + start,
      'DTEND:' + end,
      'SUMMARY:' + label,
      'DESCRIPTION:' + description,
      'BEGIN:VALARM',
      'TRIGGER:-PT' + Math.max(1, lead) + 'M',
      'ACTION:DISPLAY',
      'DESCRIPTION:' + label,
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');
    var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'littleg-' + deadline.kind + '-deadline.ics';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    var reminder = {
      enabled: true,
      kind: deadline.kind,
      due_at: deadline.due_at,
      lead_minutes: lead,
      calendar_exported: true,
      created_at: new Date().toISOString(),
      explicit_guardian_action: true
    };
    saveReminder(reminder);
    status(host, i18n('reminderExported', '日曆提醒已建立，請在裝置提示中確認加入。'), 'calendar_exported');
  }
  function registerContributor() {
    var transport = window.LittleGUploadTransport;
    if (!transport || typeof transport.registerConfirmContributor !== 'function') return;
    transport.registerConfirmContributor('reminder', function (payload) {
      var next = Object.assign({}, payload || {});
      next.notice = Object.assign({}, next.notice || {}, { reminder: reminderSnapshot() });
      return next;
    }, 40);
  }
  function restore(host) {
    var reminder = readReminder();
    if (!reminder) return;
    var kind = host.querySelector('[data-reminder-kind]');
    var lead = host.querySelector('[data-reminder-lead]');
    if (kind && reminder.kind) kind.value = reminder.kind;
    if (lead && reminder.lead_minutes) lead.value = String(reminder.lead_minutes);
    if (reminder.calendar_exported) status(host, i18n('reminderRestored', '已建立日曆提醒。'), 'calendar_exported');
  }
  function bind(host) {
    if (!host || host.getAttribute('data-reminder-bound') === VERSION) return;
    host.setAttribute('data-reminder-bound', VERSION);
    var root = host.closest(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
    syncAvailability(host);
    restore(host);
    registerContributor();
    host.addEventListener('click', function (event) {
      var action = event.target.closest('[data-reminder-action="calendar"]');
      if (!action || !host.contains(action)) return;
      event.preventDefault();
      downloadCalendar(host);
    });
    if (root) {
      root.addEventListener('littleg:notice-deadline-change', function () { syncAvailability(host); });
      root.addEventListener('littleg:upload-state-change', function () { syncAvailability(host); });
    }
  }
  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(HOST_SELECTOR), bind);
  }

  window.LittleGUploadReminders = Object.freeze({
    version: VERSION,
    getSnapshot: reminderSnapshot
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target || document); });
})(window, document);